import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from '@angular/router';
import {
  IpopRuleWorkflowEnhancementConfigurationComponent
} from './components/views/settings/ipop-rule-workflow-enhancement/ipop-rule-workflow-enhancement-configuration.component';
import {ipopConfigurationRoutePaths} from './ipop-configuration-route.service';

const enhancedRoutePath = ipopConfigurationRoutePaths.enhanced + '/:accountId';
const unsavedRuleNavigationConfirmationMessage = 'You have unsaved rule changes. Leave this page and discard them?';

@Injectable({
  providedIn: 'root'
})
export class IpopRuleWorkflowEnhancementDirtyNavigationGuard
  implements CanDeactivate<IpopRuleWorkflowEnhancementConfigurationComponent>
{
  /** Protects navigation while enhanced rule changes are unresolved. */
  canDeactivate(
    component: IpopRuleWorkflowEnhancementConfigurationComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean
  {
    let canDeactivate = true;
    const navigationAway = !this.isSamePathNavigation(currentRoute, currentState, nextState);
    if (component.hasUnresolvedRuleSave() && navigationAway) {
      canDeactivate = false;
      component.showRuleSaveNavigationBlockedMessage();
    }
    if (canDeactivate && component.hasUnsavedRuleChanges() && navigationAway) {
      canDeactivate = window.confirm(unsavedRuleNavigationConfirmationMessage);
    }

    return canDeactivate;
  }

  /** Identifies query-only navigation that keeps the enhanced account path active. */
  private isSamePathNavigation(
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean
  {
    let samePath = false;
    const enhancedRouteActive = currentRoute.routeConfig?.path === enhancedRoutePath;
    if (enhancedRouteActive && nextState) {
      const currentPath = this.getUrlPath(currentState.url);
      const nextPath = this.getUrlPath(nextState.url);
      samePath = currentPath === nextPath;
    }

    return samePath;
  }

  /** Removes query and fragment values before route path comparison. */
  private getUrlPath(url: string): string
  {
    const queryIndex = url.indexOf('?');
    const fragmentIndex = url.indexOf('#');
    let pathEndIndex = url.length;
    if (queryIndex >= 0 && queryIndex < pathEndIndex) {
      pathEndIndex = queryIndex;
    }
    if (fragmentIndex >= 0 && fragmentIndex < pathEndIndex) {
      pathEndIndex = fragmentIndex;
    }
    const path = url.substring(0, pathEndIndex);

    return path;
  }
}
